// extracted by mini-css-extract-plugin
export default {"preparation-empty":"rPCyJ","inactive-description":"_13wR7","preparation-noactiveimage":"UvFRn"};